@if (brand === 'prixtel') {
    <div>
        <p class="title">À chaque nouveau filleul : <span>1 mois de forfait offert</span></p>
        @if (sponsoredList == null || sponsoredList.data.length == 0) {
            <div class="text-center">
                <span class="bold-text">Vous n'avez pas encore de filleul.</span>
                <br/><br/>
                <p>Rendez-vous dans l'onglet "Je parraine" pour <span class="bold-text">gagner des mois de forfait gratuit !</span>
                </p>
            </div>
        }
        @if (sponsoredList && sponsoredList.data.length > 0) {
            <div>
                @for (sponsored of sponsoredList.data; track sponsored) {
                    <table class="table table-striped border-top-0 sponsoring-history">
                        <tr>
                            <td class="force-width">
                                <strong>Date du parrainage :</strong> {{ formattingDate(sponsored.updated_at) }}
                                <br/><br/>
                                @if (sponsored.nom) {
                                    <strong>Nom filleul :</strong>
                                } {{ sponsored.nom + ' ' + sponsored.pre }}
                            </td>
                            <td>
                                <strong>N° client du filleul :</strong> {{ sponsored.cid }}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <strong>État :</strong> {{ getHumanStatus(sponsored.status) }} <br/>
                                @if (sponsored.reason) {
                                    <i>{{ sponsored.status == 'failed_order' ? 'Pour raisons administratives' : sponsored.reason }}</i>
                                }
                            </td>
                        </tr>
                    </table>
                }
            </div>
        }
        @if (sponsoredList.totalItems > 5) {
            <div>
                <app-paginator></app-paginator>
            </div>
        }
        <br/><br/>
        <div class="sponsorship-content">
            <!-- href="http://pxtl.fr/docs/cgu/res" -->
            <a href="https://cdn.prixtel.com/sources/pxl/files/pdf/documentation/commun/cgu/197/parrainage_prixtel_01_2026.pdf"
               class="document" target="_blank">Conditions du parrainage Prixtel</a>
        </div>
    </div>
}
